<template>
    <div>
        <sub-menu-faturamento ativo="ciha" />

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-1">
                        <az-input
                            type="ano"
                            label="Ano Referência*"
                            v-model="anoReferencia"
                        />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            label="Mês Referência*"
                            type="select"
                            :optionsList="[
                                {
                                    value: 1,
                                    text: 'Janeiro'
                                },
                                {
                                    value: 2,
                                    text: 'Fevereiro'
                                },
                                {
                                    value: 3,
                                    text: 'Março'
                                },
                                {
                                    value: 4,
                                    text: 'Abril'
                                },
                                {
                                    value: 5,
                                    text: 'Maio'
                                },
                                {
                                    value: 6,
                                    text: 'Junho'
                                },
                                {
                                    value: 7,
                                    text: 'Julho'
                                },
                                {
                                    value: 8,
                                    text: 'Agosto'
                                },
                                {
                                    value: 9,
                                    text: 'Setembro'
                                },
                                {
                                    value: 10,
                                    text: 'Outubro'
                                },
                                {
                                    value: 11,
                                    text: 'Novembro'
                                },
                                {
                                    value: 12,
                                    text: 'Dezembro'
                                }
                            ]"
                            optionsDisplay="text"
                            optionsData="value"
                            v-model="mesReferencia"
                        />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            label="Unidade"
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas as unidades"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            v-model="unidadeOperacao"
                        />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            label="Procedimento com Código SUS"
                            class="mt-4"
                            type="checkbox-group"
                            v-model="codigo_sus"
                        />
                    </div>
                    <div class="col col-12 col-md-2 d-flex flex-column mt-4">
                        <button
                            class="btn"
                            :class="
                                !pode_gerar_ciha
                                    ? 'btn-outline-secondary'
                                    : 'btn-outline-success'
                            "
                            @click.prevent="gerar_ciha()"
                            :disabled="!pode_gerar_ciha"
                        >
                            Gerar CIHA
                        </button>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col col-12 col-md-4">
                        <az-input
                            :hli="true"
                            label="Operadoras"
                            icon="far fa-credit-card"
                            type="select"
                            optionsMode="aql"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            optionsName="operadoras.index.ciha"
                            placeholder="Selecionar Operadoras..."
                            v-model="filtros.operadora"
                            ref="operadorasRef"
                        >
                            <template v-slot:buttonposb>
                                <button
                                    class="btn btn-outline-success"
                                    @click.prevent="add_operadora()"
                                >
                                    <i class="fas fa-add text-success"></i>
                                </button>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-8">
                         <div class="container mt-4">
                            <span
                                v-for="(operadora, iix) in operadoras"
                                :key="iix"
                                class="badge badge-primary mr-1"
                            >
                                {{ operadora.st_operadora }}
                                <i
                                    class="fas fa-times ml-1"
                                    @click="operadoras.splice(iix, 1)"
                                    style="cursor: pointer"
                                ></i>
                            </span>
                         </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <div class="alert alert-info">
            Exportação do Arquivo CIHA (Comunicação de Informação Hospitalar e
            Ambulatorial)<br />
            Mais informações:
            <a
                href="https://ciha.saude.gov.br/"
                class="alert-link"
                target="_blank"
                >Clique Aqui</a
            >
        </div>

        <div v-if="logs && logs.length">
            <table class="table table-sm bg-white table-hover cabecalho-fixo">
                <thead>
                    <tr>
                        <th>Atendimento</th>
                        <th>Procedimento sem código SUS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, iix) in logs" :key="iix">
                        <td>#{{ item.atendimento }}</td>
                        <td>{{ item.procedimento }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import SubMenuFaturamento from "./SubMenuFaturamento.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import moment from "moment";
import _ from "lodash";

export default {
    components: {
        SubMenuFaturamento,
        AzInput
    },

    data() {
        return {
            anoReferencia: "",
            mesReferencia: "",
            procedimento: "",
            unidadeOperacao: "",
            codigo_sus: false,
            logs: null,
            filtros: {
                operadora: ""
            },
            operadoras: []
        };
    },

    computed: {
        pode_gerar_ciha: function() {
            return this.anoReferencia && this.mesReferencia;
        }
    },

    methods: {
        add_operadora() {
            if(this.filtros.operadora) {
                if(this.operadoras.find(operadora => operadora.id_operadora == this.filtros.operadora.id_operadora)) return;

                this.operadoras.push(this.filtros.operadora);
                this.filtros.operadora = "";
            }
        },

        gerar_ciha() {

            this.$store.commit("loading", true);

            const query = {
                q: [
                    {
                        id: "ciha",
                        name: "ciha.gerar_arquivo",
                        parms: {
                            ano: this.anoReferencia,
                            mes: this.mesReferencia,
                            id_procedimento: this.procedimento.id,
                            id_unidade_operacao: this.unidadeOperacao,
                            codigo_sus: this.codigo_sus,
                            operadoras: this.operadoras.map(operadora => operadora.id_operadora)
                        }
                    }
                ]
            };

            this.axios
                .post("/aql", query)
                .then(response => {
                    if (response.status == 200 || response.status == 201) {
                        let status = _.get(response, "data.ciha.data.status");
                        let nomeArquivo = _.get(
                            response,
                            "data.ciha.data.nome",
                            "ciha.txt"
                        );
                        let conteudo = _.get(
                            response,
                            "data.ciha.data.conteudo"
                        );
                        let msg = _.get(
                            response,
                            "data.ciha.data.msg",
                            "Erro ao gerar arquivo CIHA"
                        );
                        this.logs = _.get(response, "data.ciha.data.logs", []);

                        if (status == 200 && conteudo) {
                            var dataStr =
                                "data:text/plain;charset=utf-8," +
                                encodeURIComponent(conteudo);
                            var downloadAnchorNode = document.createElement(
                                "a"
                            );
                            downloadAnchorNode.setAttribute("href", dataStr);
                            downloadAnchorNode.setAttribute(
                                "download",
                                nomeArquivo
                            );
                            document.body.appendChild(downloadAnchorNode);
                            downloadAnchorNode.click();
                            downloadAnchorNode.remove();
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: msg,
                                life: 3000
                            });
                        }
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        }
    },

    mounted() {
        this.$store.commit("setBreadcrumb", [
            { name: "Faturamento", path: "/faturamento/guias" },
            { name: "CIHA", path: "/faturamento/ciha" }
        ]);

        this.anoReferencia = moment().year();
        this.mesReferencia = moment().month() + 1;
    }
};
</script>
<style lang=""></style>
